import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Icon, keyframes, usePrefersReducedMotion, } from '@chakra-ui/react';
import { BxLoader } from '../icons';
const spin = keyframes({
    '0%': {
        transform: 'rotate(0deg)',
    },
    '100%': {
        transform: 'rotate(360deg)',
    },
});
export const SpinnerIcon = ({ speed = '2.5s', ...props }) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    const animation = useMemo(() => prefersReducedMotion ? undefined : `${spin} ${speed} linear infinite`, [prefersReducedMotion, speed]);
    return _jsx(Icon, { animation: animation, as: BxLoader, ...props });
};
